import React, { useEffect, useState } from "react";

import CardComment from "../../atoms/card-comment/cardComment";
import CommentResponse from "../../atoms/card-comment/commentResponse";
import Modal from "../../atoms/modal/modal";
import CommentInput from "../../molecules/comment-input/commentInput";
import { likeComment } from "../../../services/tribe";

import "./commentDetailModal.scss";

interface CommentDetailModalProps {
  title: string;
  setCommentIdx: Function;
  totalComments: Array<any>;
  commentIdx: number;
  userId: string;
  userInfo: any;
  gigyaAccount: any;
  showNewCommentModal?: Function;
  setReplyCommentId?: any;
}

const CommentDetailModal = (props: CommentDetailModalProps) => {
  const {
    title,
    setCommentIdx,
    totalComments,
    commentIdx,
    userId,
    userInfo,
    setReplyCommentId
  } = props;

  const [open, setOpen] = useState(false);
  const [thisCommentIdx, setThisCommentIdx] = useState<any>(undefined);
  const [likeAvailable, setLikeAvailable] = useState(true);
  const [totalLikes, setTotalLikes] = useState(0);
  const [totalResponses, setTotalResponses] = useState(0);
  const [seeCommentsMobile, setSeeCommentsMobile] = useState(false);

  useEffect(() => {
    if (commentIdx !== undefined) {
      setOpen(true);
      setThisCommentIdx(commentIdx);
      setSeeCommentsMobile(false);
    }
  }, [commentIdx]);

  useEffect(() => {
    if (thisCommentIdx !== undefined) {
      if (totalComments[thisCommentIdx].upvotes !== undefined) {
        setLikeAvailable(
          !totalComments[thisCommentIdx].upvotes.find(
            (vote) => vote.id === userId
          )
        );
      }
      if (totalComments[thisCommentIdx].counts !== undefined) {
        setTotalLikes(totalComments[thisCommentIdx].counts.upvotes);
        setTotalResponses(totalComments[thisCommentIdx].counts.responses);
      }
      setSeeCommentsMobile(false);
    }
  }, [thisCommentIdx]);

  const handleClose = () => {
    setOpen(false);
    setCommentIdx(undefined);
  };

  const handleComment = (action: string) => {
    if (action === "next") {
      return setThisCommentIdx(
        thisCommentIdx + 1 >= totalComments.length ? 0 : thisCommentIdx + 1
      );
    } else if (action === "prev") {
      return setThisCommentIdx(
        thisCommentIdx - 1 < 0 ? totalComments.length - 1 : thisCommentIdx - 1
      );
    }
  };

  const likeAction = () => {
    likeComment(
      likeAvailable ? "LIKE" : "DISLIKE",
      totalComments[thisCommentIdx].id,
      userInfo.email
    );
    setLikeAvailable(!likeAvailable);
    setTotalLikes(likeAvailable ? totalLikes + 1 : totalLikes - 1);
  };

  const handleShowCommentsMobile = () =>
    setSeeCommentsMobile(!seeCommentsMobile);

  const adjustYTUrl = (url: string) =>
    url.replace("watch?v=", "embed/").slice(0, url.indexOf("&") - 2);

  const handleNewComment = () => {
    if (props.showNewCommentModal) {
      setOpen(false);
      setCommentIdx(undefined);
      props.showNewCommentModal(true);
      setReplyCommentId(totalComments[thisCommentIdx].id)
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => handleClose()}
      className="o-comment-detail-modal"
    >
      <div className="o-comment-detail-modal__container">
        <i
          className="o-comment-detail-modal__close icon-close"
          onClick={() => handleClose()}
        />
        <div className="o-comment-detail-modal__title-section">
          <h2 className="o-comment-detail-modal__title-section__title">
            {title}
          </h2>
          <p className="o-comment-detail-modal__title-section__index">
            {`${thisCommentIdx + 1} de ${totalComments.length} comentarios`}
          </p>
        </div>
        <div className="o-comment-detail-modal__content">
          {thisCommentIdx !== undefined &&
            totalComments[thisCommentIdx].images[0] && (
              <div className="o-comment-detail-modal__image-container">
                <img
                  className="o-comment-detail-modal__image-container__image"
                  src={totalComments[thisCommentIdx].images[0].src}
                  alt={`Imagen comentario ${totalComments[thisCommentIdx].createdAt}`}
                />
              </div>
            )}
          {thisCommentIdx !== undefined &&
            totalComments[thisCommentIdx].videos[0] &&
            !totalComments[thisCommentIdx].images[0] && (
              <div className="o-comment-detail-modal__video-container">
                <iframe
                  className="o-comment-detail-modal__video-container__video"
                  width="640"
                  height="360"
                  src={adjustYTUrl(
                    totalComments[thisCommentIdx].videos[0].original
                  )}
                />
              </div>
            )}
          <div className="o-comment-detail-modal__comment-section">
            <CardComment
              {...totalComments[thisCommentIdx]}
              userId={userId}
              userInfo={userInfo}
              handleSelection={() => false}
            />
            {totalComments[thisCommentIdx] &&
              totalComments[thisCommentIdx].responses.length > 0 && (
                <>
                  <div className="o-comment-detail-modal__comment-section__divider"></div>
                  <div className="o-comment-detail-modal__comment-section__comments">
                    {totalComments[thisCommentIdx].responses.map(
                      (response, idx) => (
                        <CommentResponse
                          key={idx}
                          {...response}
                          userInfo={userInfo}
                          userId={userId}
                        />
                      )
                    )}
                  </div>
                </>
              )}
            {props.gigyaAccount && (
              <div
                className="o-comment-detail-modal__comment-section__new-comment"
                onClick={() => handleNewComment()}
              >
                <CommentInput
                  gigyaAccount={props.gigyaAccount}
                  discussionId={
                    totalComments[thisCommentIdx] &&
                    totalComments[thisCommentIdx].id
                  }
                />
              </div>
            )}
          </div>
        </div>
        <div
          className="o-comment-detail-modal__arrow o-comment-detail-modal__arrow-left"
          onClick={() => handleComment("prev")}
        >
          <i className="o-comment-detail-modal__arrow__icon icon-chevron-left"></i>
        </div>
        <div
          className="o-comment-detail-modal__arrow o-comment-detail-modal__arrow-right"
          onClick={() => handleComment("next")}
        >
          <i className="o-comment-detail-modal__arrow__icon icon-chevron-right"></i>
        </div>
        <div className="o-comment-detail-modal__comments-mobile">
          {seeCommentsMobile &&
            totalComments[thisCommentIdx].responses.length > 0 && (
              <div className="o-comment-detail-modal__comments-mobile__comments">
                {totalComments[thisCommentIdx] &&
                  totalComments[
                    thisCommentIdx
                  ].responses.map((response, idx) => (
                    <CommentResponse
                      key={idx}
                      {...response}
                      userInfo={userInfo}
                      userId={userId}
                    />
                  ))}
              </div>
            )}
          <div className="o-comment-detail-modal__likes-comments-mobile">
            <p
              className={`o-comment-detail-modal__likes-comments-mobile__likes ${
                likeAvailable || !props.userInfo.email
                  ? ""
                  : "o-comment-detail-modal__likes-comments-mobile__likes--liked"
              }`}
              onClick={props.userInfo.email ? () => likeAction() : () => false}
            >
              <i
                className={`o-comment-detail-modal__likes-comments-mobile__likes__action ${
                  likeAvailable || !props.userInfo.email
                    ? "icon-thumbs-up"
                    : "icon-thumbs-up1"
                }`}
              />
              {totalLikes}
            </p>
            <p
              className="o-comment-detail-modal__likes-comments-mobile__comments"
              onClick={() => handleShowCommentsMobile()}
            >
              <i className="icon-comment1" />
              {totalResponses}
            </p>
          </div>
        </div>
        <div className="o-comment-detail-modal__footer-mobile">
          <p
            className="o-comment-detail-modal__footer-mobile__step"
            onClick={() => handleComment("prev")}
          >
            Atrás
          </p>
          <p className="o-comment-detail-modal__footer-mobile__page">
            <span>{thisCommentIdx + 1}</span> de {totalComments.length}
          </p>
          <p
            className="o-comment-detail-modal__footer-mobile__step"
            onClick={() => handleComment("next")}
          >
            Siguiente
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default CommentDetailModal;
